import { defaultState } from './state';

export const mutations = {
    setRoute(state, route) {
        state.route = route;
    },
    setCountry(state, country) {
        state.country = country;
    },
    setInquiry(state, inquiry) {
        state.inquiry = inquiry;
    },
    setTravelData(state, travelData) {
        state.travelData = travelData;
    },
    setInquiryType(state, inquiryType) {
        state.travelData.inquiryType = inquiryType;
    },
    setTour(state, tour) {
        state.travelData.tour = tour;
    },
    setDestinationCountry(state, destinationCountry) {
        state.travelData.destinationCountry = destinationCountry;
    },
    setDuration(state, duration) {
        state.travelData.duration = duration;
    },
    setYear(state, year) {
        state.travelData.year = year;
    },
    setMonth(state, month) {
        state.travelData.month = month;
    },
    setFullMonthName(state, fullMonthName) {
        state.travelData.fullMonthName = fullMonthName;
    },
    setGender(state, gender) {
        state.travelData.user.gender = gender
    },
    setAdults(state, adults) {
        state.travelData.groupSize.adults = adults;
    },
    setChildren(state, children) {
        state.travelData.groupSize.children = children;
    },
    setInfants(state, infants) {
        state.travelData.groupSize.infants = infants;
    },
    setBudget(state, budget) {
        state.travelData.budget = budget;
    },
    setMessage(state, message) {
        state.travelData.message = message;
    },
    setFirstName(state, firstName) {
        state.travelData.user.firstName = firstName;
    },
    setLastName(state, lastName) {
        state.travelData.user.lastName = lastName;
    },
    setEmail(state, email) {
        state.travelData.user.email = email;
    },
    setPhone(state, phone) {
        state.travelData.user.phone = phone;
    },
    setEmailValid(state, isValid) {
        state.emailValid = isValid;
    },
    setPhoneValid(state, isValid) {
        state.phoneValid = isValid;
    },
    setToS(state, tos) {
        state.travelData.tos = tos;
    },
    setMailchimpSignup(state, mailchimpSignup) {
        state.mailchimpSignup = mailchimpSignup;
    },
    setQualityValue(state, qualityValue) {
        state.travelData.qualityValue = qualityValue
    },
    setPending(state, pending) {
        state.pending = pending;
    },
    setError(state, error) {
        state.error = error;
    },
    resetTravelData(state) {
        state.travelData = { ...defaultState.travelData };
    },
};
